import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { AuraCustom } from '../styles/theme/custom-preset';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth/interceptors/auth.interceptor';
import { permissionsInterceptor } from './core/auth/interceptors/permissions.interceptor';
import { taskListStaleInterceptor } from './core/services/task-list-stale.interceptor';
import { StartupService } from './startup.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        permissionsInterceptor,
        taskListStaleInterceptor
      ])
    ),
    provideOAuthClient(),
    providePrimeNG({
      theme: {
        preset: AuraCustom,
        options: {
          darkModeSelector: false
        }
      },
    }),
    provideAppInitializer(() => {
      const startupService = inject(StartupService);
      return startupService.load();
    }),
    MessageService,
  ]
};
